import React, { ReactNode } from 'react';
import LockIcon from '@material-ui/icons/Lock';
import { AccessBadgeTitle, LockedBadgeRoot } from './styles';
import { AccessBadgeProps } from './types';

export function AccessLockBadge({
  children,
  fontSize = 16,
}: AccessBadgeProps & { children?: ReactNode }) {
  return (
    <LockedBadgeRoot style={{ fontSize }}>
      <LockIcon fontSize="inherit" />
      {children ? <AccessBadgeTitle>{children}</AccessBadgeTitle> : null}
    </LockedBadgeRoot>
  );
}
